export default {

    data: () => {
        return {
            displayStyle: 'block',
        }
    },
    methods: {
        confirmCookies(){
            let CookieDate = new Date;
            CookieDate.setFullYear(CookieDate.getFullYear() +1);
            document.cookie = 'accept_save_cookies=1; expires=' + CookieDate.toGMTString() + ';';
            this.displayStyle = 'none';
        }
    }
}
